import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import Select from "react-select";
import moment from "moment";
import { academylist } from "../../../services/admin";
import { listvisitor } from "../../../services/common";

// Read-only front desk visitor report. Filter by academy (super-admin) and a
// date range; matching visitors are shown in an ag-grid table and can be
// exported to CSV. Mirrors the other report screens.
const VisitorReport = () => {
  const isSuperAdmin = localStorage.getItem("Role") === "1";

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [fdate, setFDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [tdate, setTDate] = useState(moment().format("YYYY-MM-DD"));
  const [rowData, setRowData] = useState([]);

  const columnDefs = [
    {
      headerName: "Date",
      field: "visitor_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) =>
        params.value ? moment(params.value).format("DD-MM-YYYY") : "",
    },
    { headerName: "Name", field: "visitor_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Phone", field: "phone", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Meeting With", field: "meeting_with", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "In Time", field: "visitor_intime", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Out Time", field: "visitor_outtime", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
  ];

  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true && res.data.details.length > 0) {
        const arr = res.data.details.map((item) => ({
          value: item.id,
          label: item.name + " - " + item.code,
        }));
        setACList(arr);

        // Default to the academy chosen at login (matches other report screens).
        let defaultAca = "";
        if (localStorage.getItem("AAcademy") != null) {
          defaultAca =
            arr.find((a) => a.value == localStorage.getItem("AAcademy")) || "";
          if (defaultAca) setAcaID(defaultAca);
        }
        loadVisitors(defaultAca, fdate, tdate);
      } else {
        loadVisitors("", fdate, tdate);
      }
    });
  }, []);

  function loadVisitors(academy, from, to) {
    setRowData([]);
    const temp = new FormData();
    if (isSuperAdmin && academy && academy.value) {
      temp.append("academy_id", academy.value);
    }
    temp.append("from_date", from);
    temp.append("to_date", to);
    temp.append("status", 1);

    listvisitor(temp).then((res) => {
      if (res && res.status === true) {
        const data = res.data || [];
        setRowData(data);
      }
    });
  }

  function handleAcademy(e) {
    setAcaID(e || "");
    loadVisitors(e || "", fdate, tdate);
  }

  function handleFrom(e) {
    setFDate(e.target.value);
    loadVisitors(acaid, e.target.value, tdate);
  }

  function handleTo(e) {
    setTDate(e.target.value);
    loadVisitors(acaid, fdate, e.target.value);
  }

  const exportToCSV = () => {
    const q = (v) => `"${(v == null ? "" : String(v)).replace(/"/g, '""')}"`;
    const header = columnDefs.map((c) => c.headerName);
    const lines = rowData.map((row) =>
      columnDefs
        .map((c) => {
          let v = row[c.field];
          if (c.field === "visitor_date")
            v = v ? moment(v).format("DD-MM-YYYY") : "";
          return q(v);
        })
        .join(",")
    );
    const csv = [header.join(","), ...lines].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Visitor Report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Visitor Report</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Reports</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Visitor Report
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h2 className="main-content-title tx-24 mg-b-5">Visitor Report</h2>
            </div>
            <div className="card-body">
              <div className="row">
                {isSuperAdmin && (
                  <div className="col-xl-3 col-sm-6">
                    <label className="form-label">Select Academy</label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={acaid}
                      options={aclist}
                      onChange={handleAcademy}
                      isSearchable={true}
                      isClearable
                    />
                  </div>
                )}

                <div className="col-xl-3 col-sm-6">
                  <label className="form-label">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fdate}
                    onChange={handleFrom}
                  />
                </div>

                <div className="col-xl-3 col-sm-6">
                  <label className="form-label">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={tdate}
                    onChange={handleTo}
                  />
                </div>

                <div className="col-xl-3 col-sm-6">
                  <div className="res-right mt-5">
                    <button
                      className="btn btn-success me-2"
                      onClick={exportToCSV}
                      disabled={rowData.length === 0}
                    >
                      Excel Download
                    </button>
                  </div>
                </div>
              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={rowData}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisitorReport;
